export default __webpack_public_path__ + "static/media/wishlist.2b985240.svg";